/**
 * Video Analyzer accepts a string of video url and returns an object containing
 * video type and an optional video id.
 * @param {string} videoUrl - Url for video
 * @return {object} videoData - An object containing video type or an optional
 * video id. With Youtube and Vimeo, video id will be parsed and returned. It
 * returns null when videoUrl is invalid.
 */
export default function videoAnalyzer(videoUrl) {
  if (!videoUrl) {
    return null;
  }
  var youtubeMatchUrl = new RegExp(['^(?:https?://)?(?:www\\.)?(?:youtu\\.be/|', 'youtube\\.com/(?:embed/|v/|watch\\?v=|watch\\?.+&v=|shorts/))((\\w|-){11})(?:\\S+)?$'].join(''));
  var vimeoMatchUrl = new RegExp(['https?://(?:www\\.|player\\.)?vimeo.com', '/(?:channels/(?:\\w+/)?|groups/([^/]*)/videos', '/|album/(\\d+)/video/|video/|)(\\d+)(?:$|/|\\?)'].join(''));
  var fileMatchUrl = /\.(mp4|m4v|mov)($|\?)/i;
  var testYoutube = videoUrl.match(youtubeMatchUrl);
  var testVimeo = videoUrl.match(vimeoMatchUrl);
  var testFile = videoUrl.match(fileMatchUrl);
  var videoData = {
    videoUrl
  };
  if (testYoutube) {
    videoData.videoType = 'youtube';
    videoData.videoId = testYoutube[1];
  } else if (testVimeo) {
    videoData.videoType = 'vimeo';
    videoData.videoId = testVimeo[3];
  } else if (testFile) {
    videoData.videoType = 'file';
  } else {
    videoData = null;
  }
  return videoData;
}